import { DoDont } from '@af/design-system-docs-ui/do-dont';
import { DoDontGrid } from '@af/design-system-docs-ui/do-dont-grid';
import allButtonsDark from "../../../../src/pages/rovo-ui/button/_assets/all-buttons-dark.png";
import allButtonsLight from "../../../../src/pages/rovo-ui/button/_assets/all-buttons-light.png";
import buttonAnatomyDark from "../../../../src/pages/rovo-ui/button/_assets/button-anatomy-dark.png";
import buttonAnatomyLight from "../../../../src/pages/rovo-ui/button/_assets/button-anatomy-light.png";
import buttonDecorationDoDark from "../../../../src/pages/rovo-ui/button/_assets/button-decoration-do-dark.png";
import buttonDecorationDoLight from "../../../../src/pages/rovo-ui/button/_assets/button-decoration-do-light.png";
import buttonDecorationDontDark from "../../../../src/pages/rovo-ui/button/_assets/button-decoration-dont-dark.png";
import buttonDecorationDontLight from "../../../../src/pages/rovo-ui/button/_assets/button-decoration-dont-light.png";
import cuesStartersDark from "../../../../src/pages/rovo-ui/button/_assets/cues-starters-dark.png";
import cuesStartersLight from "../../../../src/pages/rovo-ui/button/_assets/cues-starters-light.png";
import floatingDark from "../../../../src/pages/rovo-ui/button/_assets/floating-dark.png";
import floatingLight from "../../../../src/pages/rovo-ui/button/_assets/floating-light.png";
import placementDoDark from "../../../../src/pages/rovo-ui/button/_assets/placement-do-dark.png";
import placementDoLight from "../../../../src/pages/rovo-ui/button/_assets/placement-do-light.png";
import placementDontDark from "../../../../src/pages/rovo-ui/button/_assets/placement-dont-dark.png";
import placementDontLight from "../../../../src/pages/rovo-ui/button/_assets/placement-dont-light.png";
import rovoOnlyDoDark from "../../../../src/pages/rovo-ui/button/_assets/rovo-only-do-dark.png";
import rovoOnlyDoLight from "../../../../src/pages/rovo-ui/button/_assets/rovo-only-do-light.png";
import rovoOnlyDontDark from "../../../../src/pages/rovo-ui/button/_assets/rovo-only-dont-dark.png";
import rovoOnlyDontLight from "../../../../src/pages/rovo-ui/button/_assets/rovo-only-dont-light.png";
import * as React from 'react';
export default {
  DoDont,
  DoDontGrid,
  allButtonsDark,
  allButtonsLight,
  buttonAnatomyDark,
  buttonAnatomyLight,
  buttonDecorationDoDark,
  buttonDecorationDoLight,
  buttonDecorationDontDark,
  buttonDecorationDontLight,
  cuesStartersDark,
  cuesStartersLight,
  floatingDark,
  floatingLight,
  placementDoDark,
  placementDoLight,
  placementDontDark,
  placementDontLight,
  rovoOnlyDoDark,
  rovoOnlyDoLight,
  rovoOnlyDontDark,
  rovoOnlyDontLight,
  React
};